<script>
import {actionTypePath} from "@src/functions/reteEditor";

export default {
  props: ['position', 'connection', 'editor'],
  data() {
    return {
      type: null,
      name: '',
      labelWidth: 60,
      label: ''
    }
  },
  watch: {
    name() {
      this.$nextTick(this.labelWidthRecalculate)
    }
  },
  mounted() {
    if ('type' in this.connection.data){
      this.type = this.connection.data.type
      this.name = actionTypePath[this.connection.data.type].name
      this.action = this.connection.data.action
    }
  },
  methods: {
    labelWidthRecalculate() {
      if (this.$refs.label)
        this.labelWidth = this.$refs.label.offsetWidth
    },
    onContextMenu(e) {
      this.editor.trigger('contextmenu', {
        e, node: {
          name: 'path-label',
          connection: this.connection
        }
      })
    }
  }
}
</script>

<template>
  <div
      ref="label"
      :style="`transform: translate(${position[0] - labelWidth / 2}px, ${position[1] - 10}px)`"
      class="wrap"
      @contextmenu="onContextMenu"
  >
    <p v-show="type !== 'default'" class="label">
      {{connection.data.priority}}. {{ connection.data.description || name }}
    </p>    
  </div>
</template>

<style scoped>
.wrap{
  cursor: pointer;
}

.label {
  background-color: #edeff5;
  font-size: 16px;
  font-weight: 700;
}

.actionType {
  position: absolute;
  top: -10px;
  left: 0;
  font-size: 8px;
  width: max-content;
}
</style>